import { IPrepaymentMethod } from './index'

export default function updatePrepaymentMethod(api: GlobalFetch) {
  return async function(values: IPrepaymentMethod) {
    const requestBody = {
      ...values,
      transfer_dotpay: !!(
        values.transfer_dotpay === '1' &&
        values.tdp_clientid &&
        values.tdp_token
      ),
    }

    const buildUrl = `/api/v2/misc/payment`
    const response = await api.fetch(buildUrl, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    if (response.status === 406) {
      return { error: true }
    }

    const responseBody: IData = await response.json()

    const method = responseBody.items[0]

    const switches = [
      'transfer_stripe',
      'transfer_account',
      'transfer_dotpay',
      'transfer_p24',
      'transfer_paypal',
      'transfer_payu',
      'reservation_auto_delete_status',
      'payment_on_place',
    ]

    Object.entries(method).forEach(([key, value]) => {
      if (switches.includes(key)) {
        method[key] = value === '1'
      }
    })

    return method
  }
}

export interface IData {
  messages: string[]
  items: IPrepaymentMethod[]
}
